import { HexagonSize as View } from 'ui-components'
import { useMapToolbarStore } from '~map-preview/states/mapToolbar'
import {
  Hexagon,
  Visualization
} from '~map-preview/types/__generated/gql/graphql'

export const HexagonSize = (props) => {
  const { visualization, setVisualization } = useMapToolbarStore()

  const handleChange = (event, value) => {
    const tmp = {
      ...visualization,
      hexagon: {
        ...visualization.hexagon,
        display: '2D',
        size: value
      }
    }
    setVisualization(tmp as Visualization)
  }

  const selected: Hexagon | undefined =
    visualization && (Object.values(visualization)[0] as Hexagon | undefined)

  return (
    <View
      onChange={handleChange}
      value={selected?.size}
    />
  )
}
